import Color from 'color';

export const colorsMap = {
    red: new Color("#ff5252"),
    green: new Color("#20e381"),
    purple: new Color("#ba36c9"),
    yellow: new Color("#e3b71d"),
  }